<template>
  <div>
    <div class="row">
      <div class="col-md-12 center-content">
        <div class="allergy-container">
          <div class="info center-content">
            <i class="k-icon-information"></i>
          </div>
          <div>
            {{ $t("text.allergy_title") }}
            <a class="tab-here" @click="openModal">{{ $t("text.tap_here") }}</a>
          </div>
        </div>
      </div>
    </div>
    <modal
      :ignoreBackdropClick="true"
      :show.sync="show"
      headerClasses="justify-content-center"
      class="modal-options"
      modalClasses="modal-dialog-centered modal-dialog-scrollable"
    >
      <h5 slot="header" class="title title-up">{{ $t("text.allergy_header") }}</h5>
      <div class="text-center">
        <p>{{ $t("text.allergy_body") }}</p>
        <p><a :href="`tel:${selectedLocation.telephone}`">{{selectedLocation.telephone}}</a></p>
        <p class="mt-2">{{ $t("text.allergy_body_2") }}</p>
      </div>
    </modal>
  </div>
</template>
<script>
import { Button, Modal } from "@/components";
export default {
  components: {
    [Button.name]: Button,
    Modal,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    openModal() {
      this.show = true;
    },
  },
};
</script>
<style lang="scss">
.center-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.allergy-container {
  max-width: 332px;
  background: #fff;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 0.1875rem;
  padding: 8px 0;
  display: flex;
  .info {
    width: 30%;
    i {
      font-size: 1.6rem;
      color: #f60;
    }
  }
  .tab-here {
    text-decoration: underline;
    color: #f60;
    cursor: pointer;
  }
}
</style>

